import DOMPurify from 'dompurify';

export const sanitized = (s: string | null | undefined) => {
  return s
    ? DOMPurify.sanitize(s, {
        USE_PROFILES: {
          html: false,
          mathMl: false,
          svg: false,
          svgFilters: false,
        },
      })
    : s;
};
